export default __webpack_public_path__ + "static/flag-fi-cc8288914f3370e1cebe48d7a2da5876.svg";